import IConfig from "./typings/IConfig";

export const CONFIG: IConfig = {
  /**
   * Should the question deck be shuffled?
   */
  SHUFFLE_DECK: false
};
